/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";
import { useState } from "react";
import { IconX, IconLoader2, IconUser } from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import { useFetchStaffsAllData } from "../../../apis/staffApis";
import { useAssignStaffProductManifest } from "../../../apis/productManifestApis";
import toast from "react-hot-toast";
import NewSelectInput from "../../../components/NewSelectInput";
import { useLanguage } from "../../../context/LanguageContext";

type SwapDriverModalProps = {
  open: boolean;
  onClose: () => void;
  manifest: any;
  fetchData: () => void;
  isSidebar?: boolean;
};

const SectionHeader = ({ icon: Icon, title,className="border-b border-[#FBD037]/30 pb-2 mb-3" }: { icon: any; title: string,className: string }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
      <Icon size={16} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      {title}
    </p>
  </div>
);

const AssignCheckStaff = ({
  open,
  onClose,
  manifest,
  fetchData,
  isSidebar,
}: SwapDriverModalProps) => {
  const { t } = useLanguage();
  const { data: staffData } = useFetchStaffsAllData();
  const { mutate: assignToStaff, isPending } = useAssignStaffProductManifest(
    manifest?.id,
  );
  const [assigningStaffId, setAssigningStaffId] = useState<string | null>(null);
  const [selectedStaffId, setSelectedStaffId] = useState("");

  const handleAssignStaff = (staffId: string) => {
    setAssigningStaffId(staffId);
    assignToStaff(
      { staffId },
      {
        onSuccess: () => {
          toast.success(`Manifest assigned to staff successfully`);
          setAssigningStaffId(null);
          onClose();
          fetchData();
        },
        onError: (error: any) => {
          const errorMessage =
            error?.response?.data?.message ||
            error.message ||
            "An unknown error occurred.";
          toast.error(errorMessage);
          setAssigningStaffId(null);
        },
      },
    );
  };

  if (!open) return null;

  const content = (
    <div
      className={
        isSidebar
          ? "w-full h-full flex flex-col overflow-hidden bg-[#F7F6F2]"
          : "bg-[#F7F6F2] rounded-3xl w-[500px] h-[53vh] flex flex-col overflow-hidden"
      }
    >
      {/* Header */}
      {!isSidebar && (
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h2 className="text-lg font-medium text-[#212121]">
            {t("Assign Staff (Check & Verify)")}
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-full border border-[#D2D2D2]"
            aria-label="Close modal"
          >
            <IconX size={20} />
          </button>
        </div>
      )}

      {/* Receivers List */}
      <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl overflow-y-auto  border border-[#D2D2D2]/70 p-4 m-4 transition-all duration-300 space-y-3">
        <div className="flex justify-between items-center border-b border-[#FBD037]/30 pb-2 mb-3">
          <SectionHeader className="" icon={IconUser} title={t("Staff")} />
           <button
            onClick={onClose}
            className="p-1.5 rounded-lg border border-[#D2D2D2]"
            aria-label="Close modal"
          >
            <IconX size={16} />
          </button>
        </div>
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
        {/* {staffData?.map((receiver: any) => (
          <div
            key={receiver.id}
            className="flex items-center py-1 justify-between"
          >
            <div className="flex items-center gap-2">
              <p className="text-[#212121] text-base">{receiver.name}</p>
            </div>
            <p className="text-[#212121]/70 text-sm ">{receiver.roleName}</p>
            <button
              className={`px-4 py-1 rounded-full border flex items-center space-x-2 ${
                receiver.assigned || isPending
                  ? "border-[#D2D2D2] bg-[#D9D9D9]/50 text-[#212121]/70 cursor-not-allowed"
                  : "border-[#4ADE80] bg-[#DCFCE7]/50 text-[#166534] hover:bg-[#DCFCE7]"
              }`}
              disabled={receiver.assigned || isPending}
              onClick={() =>
                !receiver.assigned &&
                !isPending &&
                handleAssignStaff(receiver.id)
              }
              aria-label={
                receiver.assigned
                  ? "Staff already assigned"
                  : `Assign ${receiver.name}`
              }
            >
              {receiver.assigned ? (
                <span>Assigned</span>
              ) : assigningStaffId === receiver.id ? (
                <IconLoader2 className="w-5 h-5 animate-spin" />
              ) : (
                <span>Assign</span>
              )}
            </button>
          </div>
        ))} */}
        {/* <div className="space-y-2">
          <select
            value={selectedStaffId}
            disabled={isPending}
            onChange={(e) => {
              const staffId = e.target.value;
              setSelectedStaffId(staffId);

              if (staffId) {
                handleAssignStaff(staffId);
              }
            }}
            className="w-full px-3 py-2 rounded-xl border border-[#D2D2D2] bg-white text-[#212121] focus:outline-none focus:ring-2 focus:ring-[#FBD037]"
          >
            <option value="">Select Staff</option>

            {staffData?.map((receiver: any) => (
              <option className="flex justify-between items-center"
                key={receiver.id}
                value={receiver.id}
                disabled={receiver.assigned}
              >
               <span className="text-sm text-[#212121]"> {receiver.name}</span> <span className="text-[#212121]/70 text-xs">({receiver.roleName})</span>
                {receiver.assigned ? " - Assigned" : ""}
              </option>
            ))}
          </select>

          {isPending && (
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <IconLoader2 className="w-4 h-4 animate-spin" />
              Assigning...
            </div>
          )}
        </div> */}
        <div className="space-y-4">
          <NewSelectInput
            name="staff"
            placeholder={t("Select Staff")}
            value={selectedStaffId}
            setValue={setSelectedStaffId}
            disabled={isPending}
            fullWidthDropdown
            selectOptions={
              staffData?.map((staff: any) => ({
                id: staff.id,
                value: staff.id,
                text: `${staff.name}  (${staff.roleName})`,
              })) || []
            }
          />
          <div className="flex justify-between items-center gap-2">
            <div className=""></div>
            <button
              disabled={!selectedStaffId || isPending}
              onClick={() => handleAssignStaff(selectedStaffId)}
              className="px-4 py-2 rounded-xl bg-[#FBD037] text-[#212121] font-medium disabled:opacity-50"
            >
              {isPending ? (
                <IconLoader2 className="w-5 h-5 animate-spin mx-auto" />
              ) : (
                t("Assign")
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  if (isSidebar) return content;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      {content}
    </div>
  );
};

export default AssignCheckStaff;
